import { Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useEffect, useState } from "react";
import Staff from "../../actions/staff";
import Roles from "../../actions/role";

import Controls from "../controls/Controls";
import { Form, useForm } from "../customHelpers/useForm";

const initialFValues = {
  fullName: "",
  phoneNo: "",
  email: "",
  editing: false,
};

const useStyles = makeStyles((theme) => ({
  icon: {
    borderRadius: "50%",
    height: "40px",
    width: "40px",
  },
}));

const UpdateStff = ({
  NotifyMessage,
  setOpenPopup,
  recordForEdit,
  getStaff,
}) => {
  const classes = useStyles();
  const { updateStaff } = Staff();
  const validate = (fieldValues = values) => {
    const temp = { ...errors };
    const regexEmail =
      /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    if ("fullName" in fieldValues)
      temp.fullName =
        fieldValues.fullName.length != 0 ? "" : "This field is required.";
    if ("phoneNo" in fieldValues)
      temp.phoneNo =
        fieldValues.phoneNo.length != 0 ? "" : "This field is required.";
    if ("email" in fieldValues) {
      if (fieldValues?.email?.length !== 0) {
        temp.email = regexEmail.test(fieldValues.email.toString().toLowerCase())
          ? ""
          : "Email is not valid.";
      }
    }

    setErrors({
      ...temp,
    });
    if (fieldValues == values) return Object.values(temp).every((x) => x == "");
  };

  const { values, errors, setValues, handleInputChange, setErrors, resetForm } =
    useForm(initialFValues, true, validate);

  useEffect(() => {
    if (recordForEdit !== null) {
      setValues({
        ...recordForEdit,
      });
    }
  }, [recordForEdit]);

  const handleSubmit = () => {
    if (validate()) {
      setValues({ ...values, submitting: true });
      delete values.logginError;
      delete values.editing;
      updateStaff(values, values.id).then((data) => {
        if (data.err) {
          setValues({ ...values, submitting: false });
          NotifyMessage({
            message: data.err,
            type: "error",
          });
        } else {
          NotifyMessage({
            message: "Staff successfully updated",
            type: "success",
          });
          setOpenPopup(false);
          resetForm();
          getStaff();
        }
      });
    }
  };

  const handleAddClick = (e) => {
    e.preventDefault();
    handleSubmit();
  };

  return (
    <Form onSubmit={handleAddClick}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Controls.Input
            name="fullName"
            label="Full Name"
            value={values.fullName}
            onChange={handleInputChange}
            error={errors.fullName}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Controls.Input
            name="email"
            label="Email"
            value={values.email}
            onChange={handleInputChange}
            error={errors.email}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Controls.Input
            name="phoneNo"
            label="Phone Number"
            value={values.phoneNo}
            onChange={handleInputChange}
            error={errors.phoneNo}
          />
        </Grid>
      </Grid>
      <Grid item xs={12} md={6}>
        <div>
          <Controls.Button
            disabled={values.submitting ? true : false}
            text={values.submitting ? "Editing..." : "Done"}
            type="submit"
          />
          <Controls.Button
            text={"Cancel"}
            color="default"
            onClick={() => {
              setOpenPopup(false);
            }}
          />
        </div>
      </Grid>
    </Form>
  );
};

export default UpdateStff;
